<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Основные документы') }}
            </v-toolbar-title>
          </v-toolbar>
          <general-error v-if="!!generalError" />
          <v-card-text>
            <v-expansion-panels multiple>
              <v-expansion-panel
                  v-for="(item,i) in items"
                  :key="i">
                <v-expansion-panel-header>
                  <div>
                    <v-icon>
                      view_list
                    </v-icon> {{ $t(item.header) }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <static-page :key="item.tag" :page-tag="item.tag" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import StaticPage from '@/components/reused/staticPages/StaticPage.vue'
  import { STATIC_PAGES_TAGS /*, DOCUMENT_TYPES */ } from '@/constants/business'

  export default {
    components: {
      GeneralError,
      StaticPage
    },
    data () {
      return {
        items: [
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_TARIFFS,
            header: this.$t('Регламент и тарифы')
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_ORG_REGISTRATION,
            header: this.$t('Шаблоны документов, необходимых для регистрации организации')
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_USER_REGISTRATION,
            header: this.$t('Шаблоны документов, необходимых для регистрации Уполномоченных представителей')
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_GUIDES,
            header: this.$t('Руководства для регистрации и работы на электронной площадке')
          },
          {
            tag: STATIC_PAGES_TAGS.STATIC_DOCS_REQUISITES,
            header: this.$t('Реквизиты счетов')

          }
        ]
      }
    }
  }
</script>
